module.exports = __webpack_public_path__ + "img/loading.b22ca59c.gif";